import { getUrlParams, getWebViewEnvSync } from "@/utils/sen";
import sensors from "sa-sdk-javascript"; // 导入神策分析SDK
console.log("sensors", process.env.VUE_APP_SERVER_URL);
const server_url = process.env.VUE_APP_SERVER_URL;

// 初始化神策分析
export function initSensorsAnalytics() {
  sensors.init({
    server_url,
    is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
    use_client_time: true,
    send_type: "beacon",
    show_log: true,
    app_js_bridge: true,
    heatmap: {
      //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
      clickmap: "default",
      //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
      scroll_notice_map: "default",
    },
  });
  sensors.use("PageLeave", {
    isCollectUrl: function () {
      return true;
    },
  });
  sensors.registerPage({
    platform_type: function () {
      let platform =
        getWebViewEnvSync() == "IOS" || getWebViewEnvSync() == "Android"
          ? "APP"
          : getWebViewEnvSync() == "miniprogram"
          ? "小程序"
          : "WAP";
      return platform;
    },
    is_login: function () {
      let isLogin = getUrlParams().token ? true : false;
      return isLogin;
    },
    page_name: function () {
      return "房贷计算器页";
    },
    city_pvar: function () {
      let cityname =
        getUrlParams().cityname || getUrlParams().cityName
          ? getUrlParams().cityname || getUrlParams().cityName
          : "北京";
      return cityname;
    },
  });
  sensors.quick("autoTrack");
}

export default sensors;
